import { AlertHelper } from '@bingads-webui-campaign/alert-helper';
import dataContextManager from '@bingads-webui-static-legacy/summary/SummaryDataContextManager';

export const onGenericError = (i18n) => {
  const alertHelper = new AlertHelper({ i18n });
  alertHelper.showError(i18n.getString(_TL_('We\'ve encountered an error and can\'t continue. Please contact support for further assistance.')));
};

export const clearCache = (pageName) => {
  dataContextManager.successEmitter.trigger('invalidate', pageName);
};
